// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609281204/js/" + chunkId + "." + {"44":"0128e22b","225":"041ea9d1","481":"4aad3fd3","486":"4b7dd4a2","770":"c2049672"}[chunkId] + ".0.17401267613000215.chunk.js";
};